import Field from '../form/field';

export default class FormField extends Field {

  constructor ($el) {
    super($el, 'form-field');

    this.messageInvalid = $el.dataset.messageInvalid;
    this.messageRequired = $el.dataset.messageRequired;

    // Bind elements
    this.$message = $el.querySelector(`.${this.classname}__message`);
    this.$placeholder = $el.querySelector(`.${this.classname}__placeholder`);
    this.$input = $el.querySelector(
      `.${this.classname}__input, .${this.classname}__select, .${this.classname}__textarea`);

    // Get field name and original help text (replaced by validation message)
    this.name = this.$input.name;
    this.helpText = this.$message.innerText;

    // Bind events and call initial change event
    this.$input.onfocus = this.onFocus.bind(this);
    this.$input.onblur = this.onBlur.bind(this);
    this.$input.oninput = this.onChange.bind(this);
    this.onChange();
  }

  /**
   * Triggered on value change.
   */
  onChange (evt) {
    const value = this.$input.value;

    // Set filled modifier depending on filled state
    this.$el.classList.toggle(`${this.classname}--filled`, !!value);

    // Validate on every change when field is currently invalid
    if (!this.valid) {
      this.validate();
    }

    if (this.delegate !== null) {
      this.delegate.fieldValueDidChange(this);
    }
  }

  /**
   * Validates field.
   * This method gets called from the parent form instance.
   * @return {boolean}
   */
  validate () {
    const value = this.getValue();

    if (!this.shouldValidate) {
      // Skip validation if field should not be validated
      return true;
    }

    // Check wether the value is empty
    if (!value) {
      // Reset message
      this.setMessage(null);

      // Verify if field is required
      if (this.required) {
        this.setPlaceholder(this.messageRequired);
        this.setValid(false);

        return false;
      }

      // Consider empty values to be valid
      this.setValid(true);
      this.setPlaceholder(null);

      return true;
    }

    let valid = true;

    switch (this.validation) {
      case 'email':
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        break;

      case 'phone':
        // eslint-disable-next-line no-useless-escape
        valid = /^\+?[\d\s\(\)-]+$/.test(value);
        break;

      case 'date':
        valid = /^[0-3][0-9]\.[0-1][0-9]\.[0-9]{4}$/.test(value);
        break;

      case 'integer':
        valid = /^\d+$/.test(value);
        break;

      case 'url':
        // eslint-disable-next-line no-useless-escape
        valid = /^(https?:\/\/)?[^\s@\/]+\.[^\s@\/]+(\/[^\s@]*)?$/.test(value);
        break;

      default:
      // No validation in place, accept every value
    }

    this.setPlaceholder();
    this.setMessage(valid ? null : this.messageInvalid);
    this.setValid(valid);

    return valid;
  }
}
